import './Banner.css'

export const Banner = () => {
    // JSX
    return (
        //<Fragment>
        <>
            <header>
                <div className="banner">
                    <img src="/imagens/banner.jpg" alt="Disputa por uma jogada na NBA" />
                </div>
                <div className="banner-logo">
                    <img src="/imagens/nba-logo.jpg" alt="Logo da NBA" />
                </div>
            </header>
        </>
            //<h1></h1>
        //</Fragment>
    )
}